import { LogService } from "@bitwarden/common/abstractions/log.service";
import { isDevMode } from "@angular/core";

export class TestLog {
  logService: LogService;

  constructor(service: LogService) {
    this.logService = service;
  }

  testLog(data: any) {
    if (isDevMode()) {
      this.logService.table(data);
    }
  }
}
